import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import toast from 'react-hot-toast';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch { toast.error('Error al enviar correo'); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#0d0d0d', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ width: '100%', maxWidth: 400 }}>
        <div style={{ background: '#1a1a1a', borderRadius: 16, padding: 32, border: '1px solid #2d2d2d' }}>
          <h2 style={{ color: 'white', fontSize: 20, fontWeight: 600, marginBottom: 8 }}>Recuperar contraseña</h2>
          {sent ? (
            <div style={{ textAlign: 'center', padding: '20px 0' }}>
              <div style={{ fontSize: 48, marginBottom: 12 }}></div>
              <p style={{ color: '#888' }}>Si el correo existe, recibirás las instrucciones en breve.</p>
              <Link to="/login" style={{ color: '#7B0D0D', display: 'block', marginTop: 16 }}>← Volver al login</Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <p style={{ color: '#888', fontSize: 14, marginBottom: 20 }}>Ingresa tu correo y te enviaremos un enlace para restablecer tu contraseña.</p>
              <div className="form-group">
                <label className="form-label" style={{ color: '#aaa' }}>Correo electrónico</label>
                <input className="form-input" type="email" required style={{ background: '#2d2d2d', border: '1px solid #3d3d3d', color: 'white' }}
                  value={email} onChange={e => setEmail(e.target.value)} placeholder="tucorreo@email.com" />
              </div>
              <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }} disabled={loading}>
                {loading ? <><span className="spinner"/>Enviando...</> : 'Enviar enlace'}
              </button>
              <Link to="/login" style={{ display: 'block', textAlign: 'center', marginTop: 16, color: '#666', fontSize: 14 }}>← Volver</Link>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
